import moment from 'moment';
import TableCompHead from '../../../../../components/ui/TableCompHead';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import AutocompleteMuiCustom from '../../../../../components/common/AutocompleteMuiCustom';
import { TimePicker } from '@mui/x-date-pickers';
import { TableInput } from '../../../../../components/common';
import { convToTime } from '../../../../../utils/helpers';
import { useQuery } from '../../../../../hooks/UseQuery';

interface IProps {
  moduleData: any;
  isView: boolean;
  machineData: any;
  departmentData: any;
  setRender: any;
}

const THead = ({
  moduleData,
  isView,
  machineData,
  departmentData,
  setRender,
}: IProps) => {
  const rowDate = useQuery('date') || '';
  return (
    <thead>
      <TableCompHead
        colSpan={3}
        rowSpan={1}
        labels={['Doc No.:']}
        values={['F/MNT/09/00']}
        heading="Break Down Slip"
      />
      <tr>
        <th align="left">
          Department:
          {isView ? (
            moduleData?.department_id?.department_name
          ) : (
            <AutocompleteMuiCustom
              id="Department"
              label=""
              option_name="department_name"
              key={'department'}
              arrayofObj={departmentData}
              value={moduleData?.department_id || ''}
              onChange={(e: any, value) => {
                if (value) moduleData.department_id = value;
                setRender((prev: any) => !prev);
              }}
              sx={{ width: '350px' }}
            />
          )}
        </th>
        <th align="left" colSpan={2}>
          M/C No :
          {isView ? (
            moduleData?.machine_id?.machine_no
          ) : (
            <AutocompleteMuiCustom
              id="Machine No."
              label="Machine"
              option_name="machine_no"
              key={'machine'}
              arrayofObj={machineData}
              value={moduleData?.machine_id || ''}
              onChange={(e, value) => {
                if (value) moduleData.machine_id = value;
                setRender((prev: any) => !prev);
              }}
              sx={{ width: '350px' }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th align="left">
          Break down Date :
          {isView ? (
            formatDate(moduleData.moduleData_Date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.moduleData_Date)}
              onChange={(date: any) => {
                moduleData.moduleData_Date = date;
                setRender((prev: any) => !prev);
              }}
            />
          )}
        </th>
        <th align="left"  colSpan={2}>
          Time:
          {isView ? (
            convToTime(moduleData.time)
          ) : (
            <TimePicker
              value={moment(moduleData.time)}
              onChange={(date) => {
                moduleData.time = date;
                setRender((prev: any) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th colSpan={3} align="left">
          Type of Breakdown
          <TableInput
            isView={isView}
            name="type_of_breakdown"
            type="text"
            value={moduleData.type_of_breakdown}
            onChange={(e) => {
              moduleData.type_of_breakdown = e.target.value;
              setRender((prev: any) => !prev);
            }}
          />
          {/* {['Mechanical', 'Electrical', 'Electronic', 'Fixture'].map(
            (option, index) => (
              <span
                key={index}
                style={{ marginLeft: '10px', marginRight: '10px' }}
              >
                {option}
                <Checkbox
                  checked={moduleData.type_of_breakdown === option}
                  onChange={(e) => {
                    moduleData.type_of_breakdown = option;
                    setRender((prev: any) => !prev);
                  }}
                  disabled={isView}
                />
              </span>
            )
          )} */}
        </th>
      </tr>
<tr>
        <th align="left">
          Machine Handover Date :
          {isView ? (
            formatDate(moduleData.machine_handover_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.machine_handover_date)}
              onChange={(date: any) => {
                moduleData.machine_handover_date = date;
                setRender((prev: any) => !prev);
              }}
            />
          )}
        </th>
        <th align="left"  colSpan={2}>
          Machine Handover Time :
          {isView ? (
            convToTime(moduleData.machine_handover_time)
          ) : (
            <TimePicker
              value={moment(moduleData.machine_handover_time)}
              onChange={(date) => {
                moduleData.machine_handover_time = date;
                setRender((prev: any) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        <th align="left" colSpan={3}>
          Total Breakdown Hrs. :
           <TableInput
            isView={isView}
            name="breakdown_hrs"
            type="text"
            value={moduleData.breakdown_hrs}
            onChange={(e) => {
              moduleData.breakdown_hrs = e.target.value;
              setRender((prev: any) => !prev);
            }}
          />
        </th>
      </tr>
      <tr>
        <th align="left">
          Supervisor Prod. :
          <TableInput
            isView={isView}
            name="supervisor_prod"
            type="text"
            value={moduleData.supervisor_prod}
            onChange={(e) => {
              moduleData.supervisor_prod = e.target.value;
              setRender((prev: any) => !prev);
            }}
          />
        </th>
         <th align="left" colSpan={2}>
          Supervisor MTC :
          <TableInput
            isView={isView}
            name="supervisor_mtc"
            type="text"
            value={moduleData.supervisor_mtc}
            onChange={(e) => {
              moduleData.supervisor_mtc = e.target.value;
              setRender((prev: any) => !prev);
            }}
          />
         </th>
      </tr>
    </thead>
  );
};

export default THead;
